export const COLUMN_FIXED_WIDTH_NARROW = 60;
export const COLUMN_FIXED_WIDTH = 95;
export const COLUMN_FIXED_WIDTH_WIDE = 120;
export const COLUMN_FIXED_WIDTH_EXTRA_WIDE = 240;

export const CONNECTOR_WIDGET_ROW_SIZE = 4; // NB: when updating, also update the width of the Flex child element in the DeviceConnectors.scss

export const notifyPosition = "bottom center";
export const notifyDuration = 4000;
export const notifyDurationLong = 6000;

export const ALL_ORGANISATIONS_URL_KEY = "all-organisations";
export const LOGICAL_CAAS_KEY = "Logical-CaaS-All";
export const ALL_SITES_URL_KEY = "all-sites";
export const ALL_DEVICES_URL_KEY = "all-devices";
export const JETCHARGE_STAFF_ORG = "JETChargeStaff";
export const ILLUMINATE_ADMIN_ORG = "IlluminateAdmin";
export const RFID_REMOTESTART_PREFIX_USERACCOUNT = "UserAccount-";
export const START_CHARGE_TASK_TAG_ID_PREFIX_USERACCOUNT = "UA_";
export const SITE_TAG_PREFIX = "Site-";
export const SERVICE_MODEL_TAG_PREFIX = "ServiceModel-";
export const END_USER_OWNER_PREFIX = "EndUserOwner-";

//User flows for ADB2C auth only, not used for AD auth
export const SIGNUP_USERFLOW = "B2C_1_enterprise_signup1";
export const NO_MFA_SIGNIN_USERFLOW = "B2C_1_enterprise_signin_nomfa1";
export const SIGNIN_USERFLOW =
    import.meta.env.VITE_ADB2C_USER_FLOW ?? "B2C_1A_ENTERPRISE_SIGNIN";
export const RESET_PASSWORD_USERFLOW =
    import.meta.env.VITE_ADB2C_USER_FLOW_RESETPW ??
    "B2C_1_enterprise_resetpassword1";
export const MSAL_REDIRECT_PAGE_URL = "/auth-redirect";

export const SITE_LIST_LOAD_ERROR_MESSAGE = "Error: Cannot load the Sites list";
export const DEVICE_STATUS_LOAD_ERROR_MESSAGE =
    "Error: Cannot load device statuses";
export const CONNECTOR_STATUS_LOAD_ERROR_MESSAGE =
    "Error: Cannot load the connector statuses";

//State storage keys
export const UPTIME_DASHBOARD_STATE_STORAGE_KEY = "uptimePageState";
export const DEVICE_LIST_STATE_STORAGE_KEY = "devicesPageState";
export const MAINTENANCE_STATE_STORAGE_KEY = "maintenancePageState";
export const HOME_STATE_STORAGE_KEY = "homePageState";
export const FAULTS_OFFLINE_STATE_STORAGE_KEY = "faultsPageOfflineState";
export const FAULTS_FAULTED_STATE_STORAGE_KEY = "faultsPageFaultedState";
export const FAULTS_UNKNOWN_STATE_STORAGE_KEY = "faultsPageUnknownState";
export const FAULTS_NON_OPERATIONAL_STATE_STORAGE_KEY =
    "faultsPageNonOperationalState";
export const WHATS_NEW_LAST_DISMISSED_SLUG_STORAGE_KEY =
    "whatsNewLastDismissedSlug";
export const SHOW_DECOMMISSIONED_DEVICES_STORAGE_KEY =
    "showDecommissionedDevices";
export const SHOW_ARCHIVED_VEHICLES_STORAGE_KEY = "showArchivedVehicles";
// Onboarding tutorial state is keyed per user: `${prefix}_{userAccountId}`.
export const ONBOARDING_TUTORIAL_STORAGE_KEY_PREFIX = "illuminate_onboarding";

export const METRIC_HIGH_THRESHOLD = 95;
export const METRIC_MODERATE_THRESHOLD = 65;

//Feature Flags
export enum FeatureFlag {
    HIDE_MAPS = "hide-maps", // PERMANENT FLAG, DO NOT REMOVE IN CLEAN UP
    IL_2630_WHATS_NEW = "release-il-1326-whats-new", // PERMANENT FLAG, DO NOT REMOVE IN CLEAN UP
    PAYMENT_LOGS_FEATURE_FLAG = "release-payment-logs",
    TARIFF_FEATURE_FLAG = "release-tariff-management",
    CORE_STATUS = "release-core-status",
    POWER_METER_STATUS_FLAG = "release-power-meter-status",
    POWER_METER_ONLINE_OFFLINE_STATUS_FLAG = "release-power-meter-online-offline-status",

    // Core configuration.
    COREV2_SITE_DIAGRAM_FLAG = "release-corev2-2344-site-diagram", // Epic COREV2-2344.
    COREV2_2585_ENABLE_FEEDBACK_FIELD_FLAG = "release-corev2-2585-enable-feedback-field-in-core-config-ui", // Epic COREV2-2585.

    // MTA Energy.
    MTA_PRICING_POC_FLAG = "release-corev-2-1702-mta-energy-fcp-demand-poc", // Epic COREV2-1702.

    // Core Tech Debt.
    CORE_DEVICE_DETAILS_DB_GRAPH_FEEDBACK_VALUES_FLAG = "release-corev-2-2115-core-db-graph-feeback-values", // Epic COREV2-2086.
    CORE_EXPORT_CHARGER_LOGS_FLAG = "release-corev-2-2268-export-charger-logs", // Epic COREV2-2268.
    CORE_DEVICE_DETAILS_ACTIVE_PROFILE_FLAG = "release-corev-2-2318-display-active-profile-on-core-device-page", // Epic COREV2-2318.

    OCPP_2_TRANSACTION_ID_FLAG = "release-ocpp-2-transaction-id",
    CONFIG_IL_2488_MIN_CORE_FW_VERSION_FOR_STATUS = "config-il-2488-min-core-fw-version-for-status",
    IL_2869_DEVICE_PROVISIONING = "release-il-2869-device-provisioning",
    IL_3133_SERVICE_MODEL = "release-il-3133-service-model",
    IL_3373_HOME_PAGE_SERVICE_MODEL = "release-il-3373-home-page-service-model",
    IL_3417_FAULTS_ALERTS_UPTIME_SERVICE_MODEL = "release-il-3417-faults-alerts-uptime-service-model",
    PL_227_REPORT_ACTIVE_PROTOCOL_UI = "release-pl-227-show-protocol-version",
    IL_3329_BULK_SET_OPERATIONAL = "release-il-3329-bulk-set-operational",
    IL_3334_BULK_ASSIGN = "release-il-3334-bulk-assign",
    IL_3429_NEM12_ADHOC_REPORTS = "release-il-3429-nem12-adhoc-reports",
    IL_3306_FILTER_PREFERENCE = "release-il-3306-filter-preference",
    IL_3114_CSR = "release-il-3114-csr",
    IL_3675_SET_DEFAULT_RFID = "release-il-3675-set-default-rfid",
    IL_3705_PREVENTATIVE_PLANNED_MAINTENANCE = "release-il-3705-preventative-planned-maintenance",
    IL_3753_ATTACHMENTS_EVERYWHERE = "release-il-3753-attachments-everywhere",
    IL_3658_BILLING_DEVICE_INVITE = "release-il-3658-billing-device-invite",
    PL_495_SET_DISPLAYED_PRICE = "release-pl-495-set-displayed-price", // DO NOT REMOVE FF, IT WILL BE ENABLED FOR SOME USERS
    AI_CHATBOT_HELPER = "ai-chatbot-helper",
    IL_3835_REPORT_FAULT_MODAL = "release-il-3835-report-fault-modal",
    IL_2582_ADVANCED_DEVICE_SEARCH = "release-il-2582-advanced-device-search",
    IL_3897_EDIT_CONNECTOR = "release-il-3897-edit-connector",
    IL_3964_BULK_RFID_SIMPLE = "release-il-3964-bulk-rfid-simple",
    IL_3918_VEHICLE_MANAGEMENT = "release-il-3918-vehicle-management",
    IL_3977_RFID_UPLIFT = "release-il-3977-rfid-uplift",
    COREV2_CORE_CONFIG_CHANGELOG = "COREV2_CORE_CONFIG_CHANGELOG",
    IL_3981_OPERATIONAL_FILTER = "release-il-3981-operational-filter",
    IL_3802_PERSIST_TABLE_SORTING = "release-il-3802-persist-table-sorting",
    IL_4026_UPLIFT_FAULTS_DASHBOARD = "il-4026-uplift-faults-dashboard",
    PL_719_WARNING_BANNER = "release-pl-719-websocket-gateway-migration-banner",
    IL_3944_VEHICLE_REPORT = "release-il-3944-vehicle-report",
    IL_4045_DOWNLOAD_LOG_DATA = "release-il-4045-download-log-data",
    IL_3955_NZ_COUNTRY_CODE = "release-il-3955-nz-country-code",
    IL_4077_TANSTACK_ODATA_TABLES = "release-il-4077-tanstack-odata-tables",
    IL_3970_LOW_ENERGY_MID_SESSION_VIEW = "release-il-3970-low-energy-mid-session-alerts-view",
    IL_4049_PASSTHROUGH_STATUS_DEVICE_DETATILS = "release-il-4049-status-device-details",
    IL_4063_VEHICLE_MODEL_CATALOG = "release-il-4063-vehicle-model-catalog",
    IL_3841_ORG_SEARCH_INCLUDE_PARENT_ORG_FIELD = "release-il-3841-org-search-include-parent-org-field",
    IL_4090_ONBOARDING_TUTORIAL_CUSTOMER = "release-il-4090-onboarding-tutorial-customer",
    IL_3915_DEVICE_CATALOGUE = "release-il-3915-device-catalogue",
    IL_4116_UPLIFT_CORE_GRAPH = "release-il-4116-uplift-core-graph",
    IL_4145_MIGRATE_DEVICE_DATAGRID = "release-il-4145-migrate-device-datagrid",
    IL_4072_WEBHOOK_DISABLE_ENABLE = "release-il-4072-webhook-disable-enable",
    IL_4166_WEBHOOKS_UPLIFT = "release-il-4166-webhooks-uplift",
    IL_4187_LOAD_MANAGEMENT = "release-il-4187-load-management",
    IL_4181_ASAT = "release-il-4181-asat-rocky-uplift",
    IL_4193_CORE_INFO_ON_SITE_OVERVIEW = "release-il-4193-core-info-on-site-overview",
    IL_4147_ONLINE_STATUS_LOGS_PAGINATION = "release-il-4147-device-online-status-logs-page-ignores-pagination",
    IL_4204_CONFIG_SITE_TREE = "release-il-4204-config-site-tree",
    IL_4148_STREAM_CHATBOT_RESPONSES = "release-il-4148-stream-chatbot-responses",
    IL_4194_POWER_MOVE = "release-il-4194-power-move", //Brand Refresh
    IL_4162_MULTI_PAYMATE_CONNECTORS = "release-il-4162-multi-paymate-connectors",
    IL_3786_IDLE_STATE_NOTIFICATIONS = "release-il-3786-idle-state-notifications",
    EM_25_OFFERS = "release-em-25-offers",
}

// Access tags
export enum AccessTag {
    JETCharge = "JETCharge",
}

//Amplitude Events
/** Amplitude Event Names */
export const enum AmplitudeEvent {
    DEVICE_MAINTENANCE_HARD_RESET_CLICKED = "deviceMaintenance_hardReset_clicked",
    DEVICE_MAINTENANCE_SOFT_RESET_CLICKED = "deviceMaintenance_softReset_clicked",
    CREATE_REPORT_DOWNLOAD_CLICKED = "createReport_download_clicked",
    CREATE_REPORT_VIEW_CLICKED = "createReport_view_clicked",
    SCHEDULED_REPORTS_CREATE_CLICKED = "scheduledReports_create_clicked",
    CREATE_SCHEDULED_REPORT_SAVE_CLICKED = "createScheduledReport_save_clicked",
    UPTIME_DASHBOARD_EXCLUDE_OFFLINE_CLICKED = "uptimeDashboard_excludeOffline_clicked",
    RFID_CREATE_TAG_CLICKED = "rfids_createTag_clicked",
    CREATE_RFID_TAG_CREATE_CLICKED = "createRfidTag_create_clicked",
    USERS_INVITE_CLICKED = "users_invite_clicked",
    USERS_EDIT_CLICKED = "users_edit_clicked",
    INVITE_USER_INVITE_CLICKED = "inviteUser_invite_clicked",
    DEVICE_MAINTENANCE_UNLOCK_CLICKED = "deviceMaintenance_unlock_clicked",
    DEVICE_MAINTENANCE_REMOTE_START_STOP_CLICKED = "deviceMaintenance_remoteStartStop_clicked",
    FAULTED_DEVICES_FILTER_BY_CLICKED = "faultedDevices_filterBy_clicked",
    OFFLINE_DEVICES_FILTER_BY_CLICKED = "offlineDevices_filterBy_clicked",
    UNKNOWN_DEVICES_FILTER_BY_CLICKED = "unknownDevices_filterBy_clicked",
    WARNINGS_FILTER_BY_CLICKED = "warnings_filterBy_clicked",
    FAULTED_DEVICES_TAB_CLICKED = "faultedDevices_tab_clicked",
    OFFLINE_DEVICES_TAB_CLICKED = "offlineDevices_tab_clicked",
    UNKNOWN_DEVICES_TAB_CLICKED = "unknownDevices_tab_clicked",
    NON_OPERATIONAL_DEVICES_TAB_CLICKED = "nonOperationalDevices_tab_clicked",
    WARNINGS_TAB_CLICKED = "warnings_tab_clicked",
    DEVICE_QUICK_ACTION_RELOAD_CONFIG_CLICKED = "deviceQuickAction_reloadConfig_clicked",
    DEVICE_QUICK_ACTION_CLEAR_CHARGING_PROFILE_CLICKED = "deviceQuickAction_clearChargingProfile_clicked",
    DEVICE_QUICK_ACTION_CHANGE_AVAILABILITY_CLICKED = "deviceQuickAction_changeAvailability_clicked",
    DEVICE_QUICK_ACTION_ACTIVATE_DEACTIVATE_CLICKED = "deviceQuickAction_activateDeactivate_clicked",
    DEVICE_QUICK_ACTION_SUPERVISION_MODE_CLICKED = "deviceQuickAction_supervisionMode_clicked",
    DEVICE_QUICK_ACTION_RELOAD_CONNECTION_CLICKED = "deviceQuickAction_reloadConnection_clicked",
    DEVICE_QUICK_ACTION_OPERATIONAL_STATUS_CLICKED = "deviceQuickAction_operationalStatus_clicked",
    DEVICE_QUICK_ACTION_DECOMMISSION_CLICKED = "deviceQuickAction_decommission_clicked",
    DEVICE_QUICK_ACTION_UNDO_DECOMMISSION_CLICKED = "deviceQuickAction_undoDecommission_clicked",
    DEVICE_QUICK_ACTION_ARCHIVE_CLICKED = "deviceQuickAction_archive_clicked",
    DECOMMISSION_MODAL_DECOMMISSION_CLICKED = "decommissionModal_decommission_clicked",
    REPROVISION_MODAL_REPROVISION_CLICKED = "reprovisionModal_reprovision_clicked",
    DEVICES_LIST_REPROVISION_CLICKED = "devicesList_reprovision_clicked",
    CREATE_SERVICE_MODEL_MODAL_SAVE_CLICKED = "createServiceModelModal_save_clicked",
    EDIT_SERVICE_MODELS_MODAL_SAVE_CLICKED = "editServiceModelsModal_save_clicked",
    DELETE_SERVICE_MODEL_MODAL_DELETE_CLICKED = "deleteServiceModelModal_delete_clicked",
    ASSIGN_DEVICES_MODAL_ASSIGN_CLICKED = "assignDevicesModal_assign_clicked",
    REMOVE_DEVICE_IN_SERVICE_LEVEL_MODAL_REMOVE_CLICKED = "removeDeviceInServiceLevelModal_remove_clicked",
    DEVICE_QUICK_ACTION_GO_TO_ACTION_LOG_CLICKED = "deviceQuickAction_gotoActionLog_clicked",
    DEVICE_QUICK_ACTION_GO_TO_PAYMENT_LOG_CLICKED = "deviceQuickAction_gotoPaymentLog_clicked",
    DEVICE_QUICK_ACTION_GO_TO_MESSAGE_LOG_CLICKED = "deviceQuickAction_gotoMessageLog_clicked",
    DEVICE_QUICK_ACTION_GO_TO_CORE_SITE_CONFIGURATION_LOG_CLICKED = "deviceQuickAction_gotoCORESiteConfigurationLog_clicked",
    DEVICE_QUICK_ACTION_GO_TO_LOAD_MANAGEMENT_CLICKED = "deviceQuickAction_gotoLoadManagement_clicked",
    DEVICE_QUICK_ACTION_UPDATE_FIRMWARE_CLICKED = "deviceQuickAction_updateFirmware_clicked",
    DEVICE_QUICK_ACTION_REPORT_FAULT_CLICKED = "deviceQuickAction_reportFault_clicked",
    DEVICE_QUICK_ACTION_REPORT_FAULT_SUBMITTED = "deviceQuickAction_reportFault_submitted",
    CONNECTOR_QUICK_ACTION_START_TRANSACTION_CLICKED = "connectorQuickAction_startTransaction_clicked",
    CONNECTOR_QUICK_ACTION_STOP_TRANSACTION_CLICKED = "connectorQuickAction_stopTransaction_clicked",
    CONNECTOR_QUICK_ACTION_UNLOCK_CABLE_CLICKED = "connectorQuickAction_unlockCable_clicked",
    CONNECTOR_QUICK_ACTION_TOGGLE_TETHERED_CLICKED = "connectorQuickAction_toggleTethered_clicked",
    CONNECTOR_QUICK_ACTION_CHANGE_AVAILABILITY_CLICKED = "connectorQuickAction_changeAvailability_clicked",
    EDIT_SITE_CONTACTS_ADD_CONTACT_CLICKED = "editSiteContacts_addContact_clicked",
    EDIT_SITE_CONTACTS_SAVE_CONTACT_CLICKED = "editSiteContacts_saveContact_clicked",
    CORE_CONFIG_SAVED = "core_config_saved",
    CORE_CONFIG_SAVED_ERROR = "core_config_save_error",
    CORE_CONFIG_UPDATED_PARENT = "core_config_updated_parent",
    CORE_CONFIG_UPDATED_PARENT_ERROR = "core_config_updated_parent_error",
    CORE_CONFIG_PUSHED_TO_CORE = "core_config_pushed_to_core",
    CORE_CONFIG_PUSHED_TO_CORE_ERROR = "core_config_push_to_core_error",
    CORE_CONFIG_EDIT_POWER_METER_ERROR = "core_config_edit_power_meter_error",
    CORE_CONFIG_ENTRY_PARSE_ERROR = "core_config_entry_parse_error",
    FAULTED_DEVICES_DETAILS_CLICKED = "faultedDevices_details_clicked",
    OFFLINE_DEVICES_DETAILS_CLICKED = "offlineDevices_details_clicked",
    WARNINGS_DETAILS_CLICKED = "warnings_details_clicked",
    HOME_PAGE_GO_TO_DASHBOARDS_CLICKED = "homePage_goToDashboards_clicked",
    HOME_PAGE_SUMMARY_UPTIME_TAB_CLICKED = "homePage_summaryUptimeTab_clicked",
    HOME_PAGE_SUMMARY_ENERGY_USAGE_TAB_CLICKED = "homePage_summaryEnergyUsageTab_clicked",
    HOME_PAGE_SUMMARY_SESSIONS_TAB_CLICKED = "homePage_summarySessionsTab_clicked",
    HOME_PAGE_SUMMARY_SUCCESS_RATE_TAB_CLICKED = "homePage_summarySuccessRateTab_clicked",
    HOME_PAGE_VIEW_MAINTENANCE_TICKETS_CLICKED = "homePage_viewMaintenanceTickets_clicked",
    HOME_PAGE_VIEW_ALL_SITES_CLICKED = "homePage_viewAllSites_clicked",
    HOME_PAGE_VIEW_ALL_DEVICES_CLICKED = "homePage_viewAllDevices_clicked",
    DEVICE_LIST_ORGANISATIONS_FILTER_CLICKED = "deviceList_organisationsFilter_clicked",
    DEVICE_LIST_SITE_FILTER_CLICKED = "deviceList_siteFilter_clicked",
    DEVICE_LIST_STATUS_FILTER_CLICKED = "deviceList_statusFilter_clicked",
    DEVICE_LIST_CONNECTIVITY_FILTER_CLICKED = "deviceList_connectivityFilter_clicked",
    DEVICE_LIST_SERVICE_MODAL_FILTER_CLICKED = "deviceList_serviceModalFilter_clicked",
    DEVICE_LIST_TYPE_FILTER_CLICKED = "deviceList_typeFilter_clicked",
    DEVICE_LIST_OPERATIONAL_FILTER_CLICKED = "deviceList_operationalFilter_clicked",
    DEVICE_LIST_TOGGLE_DECOMMISSIONED_VISIBILITY_CLICKED = "deviceList_toggleDecommissionedVisibility_clicked",
    SITES_FAVOURITE_FILTER_CLICKED = "sites_favouriteFilter_clicked",
    SITES_FAVOURITE_CLICKED = "sites_favourite_clicked",
    SITE_PAGE_SUMMARY_UPTIME_TAB_CLICKED = "sitePage_summaryUptimeTab_clicked",
    SITE_PAGE_SUMMARY_ENERGY_USAGE_TAB_CLICKED = "sitePage_summaryEnergyUsageTab_clicked",
    SITE_PAGE_SUMMARY_SESSIONS_TAB_CLICKED = "sitePage_summarySessionsTab_clicked",
    EDIT_SITE_SAVE_CLICKED = "editSite_save_clicked",
    NOTIFICATIONPREFERENCES_CREATEPREFERENCE_CLICKED = "notificationPreferences_createPreference_clicked",
    CREATENOTIFICATIONPREFERENCES_CREATE_CLICKED = "createNotificationPreferences_create_clicked",
    GLOBAL_SEARCH_CLICKED = "global_search_clicked",
    GLOBAL_HELP_CLICKED = "global_help_clicked",
    GLOBAL_SETTINGS_CLICKED = "global_settings_clicked",
    STATUSHISTORY_DATEFILTER_CLICKED = "statusHistory_dateFilter_clicked",
    STATUSHISTORY_CONNECTORFILTER_CLICKED = "statusHistory_connectorFilter_clicked",
    STATUSHISTORY_STATUSFILTER_CLICKED = "statusHistory_statusFilter_clicked",
    DEVICEDETAILS_SUMMARYUPTIMETAB_CLICKED = "deviceDetails_summaryUptimeTab_clicked",
    DEVICEDETAILS_SUMMARYENERGYUSAGETAB_CLICKED = "deviceDetails_summaryEnergyUsageTab_clicked",
    DEVICEDETAILS_SUMMARYSESSIONSTAB_CLICKED = "deviceDetails_summarySessionsTab_clicked",
    CONNECTIVITYHISTORY_DATEFILTER_CLICKED = "connectivityHistory_dateFilter_clicked",
    CONNECTIVITYHISTORY_STATUSFILTER_CLICKED = "connectivityHistory_statusFilter_clicked",
    CONNECTIVITYHISTORY_SEARCH_CLICKED = "connectivityHistory_search_clicked",
    DEVICEDETAILS_DEVICEEDIT_CLICKED = "deviceDetails_deviceEdit_clicked",
    EDITDETAILSMODAL_SAVE_CLICKED = "editDetailsModal_save_clicked",
    CONFIGURATION_EDITCONNECTION_CLICKED = "configuration_editConnection_clicked",
    CONFIGURATION_EDITCONNECTIONSAVE_CLICKED = "configuration_editConnectionSave_clicked",
    CONFIGURATION_EDITACCESSGROUPS_CLICKED = "configuration_editAccessGroups_clicked",
    CONFIGURATION_EDITACCESSGROUPSSAVE_CLICKED = "configuration_editAccessGroupsSave_clicked",
    CONFIGURATION_CREATEPASSTHROUGH_CLICKED = "configuration_createPassthrough_clicked",
    CONFIGURATION_CREATEPASSTHROUGHCREATE_CLICKED = "configuration_createPassthroughCreate_clicked",
    CONFIGURATION_CREATEINVITECODE_CLICKED = "configuration_createInviteCode_clicked",
    CONFIGURATION_CREATEINVITATIONCODECREATE_CLICKED = "configuration_createInvitationCodeCreate_clicked",
    CONFIGURATION_ADDCONFIGURATIONITEM_CLICKED = "configuration_addConfigurationItem_clicked",
    CONFIGURATION_ADDCONFIGURATIONITEMSAVE_CLICKED = "configuration_addConfigurationItemSave_clicked",
    CONFIGURATION_SEARCH_CLICKED = "configuration_search_clicked",
    DEVICEDETAILS_VIEWALLTRANSACTION_CLICKED = "deviceDetails_viewAllTransaction_clicked",
    DEVICE_COPYLOGS_CLICKED = "device_copyLogs_clicked",
    DEVICE_DOWNLOADLOGS_CLICKED = "device_downloadLogs_clicked",
    VEHICLES_LIST_STATUS_FILTER_CLICKED = "vehicles_list_status_filter_clicked",
    VEHICLES_LIST_ORGANISATIONS_FILTER_CLICKED = "vehicles_list_organisations_filter_clicked",
    VEHICLES_LIST_VEHICLE_TYPE_FILTER_CLICKED = "vehicles_list_vehicle_type_filter_clicked",
    VEHICLES_LIST_TOGGLE_ARCHIVED_VISIBILITY_CLICKED = "vehicles_list_toggleArchivedVisibility_clicked",
    CREATE_VEHICLE_CLICKED = "create_vehicle_clicked",
    EDIT_VEHICLE_CLICKED = "edit_vehicle_clicked",
    VEHICLES_LIST_MAKE_FILTER_CLICKED = "vehicles_list_make_filter_clicked",
    VEHICLES_LIST_MODEL_FILTER_CLICKED = "vehicles_list_model_filter_clicked",
    VEHICLEDETAILS_SUMMARYSESSIONSTAB_CLICKED = "vehicleDetails_summarySessionsTab_clicked",
    VEHICLEDETAILS_SUMMARYENERGYUSAGETAB_CLICKED = "vehicleDetails_summaryEnergyUsageTab_clicked",
    VEHICLEDETAILS_SUMMARYCOSTTAB_CLICKED = "vehicleDetails_summaryCostTab_clicked",

    // Site Configuration.
    SITECONFIGURATION_ADMAIN_DISTRIBUTION_BOARD_CLICKED = "siteConfiguration_addMainDistributionBoard_clicked",
    MAIN_DISTRIBUTION_BOARD_MODAL_ADVANCED_SETTINGS_CLICKED = "mainDistributionBoardModal_advancedSettings_clicked",
    SITECONFIGURATION_SAVE_CONFIGURATION_CLICKED = "siteConfiguration_saveConfiguration_clicked",
    SITECONFIGURATION_ABANDON_CONFIGURATION_CLICKED = "siteConfiguration_abandonConfiguration_clicked",
    SITECONFIGURATION_EDIT_MAIN_DISTRIBUTION_BOARD_CLICKED = "siteConfiguration_editMainDistributionBoard_clicked",
    SITECONFIGURATION_ADDSUB_DISTRIBUTION_BOARD_CLICKED = "siteConfiguration_addSubDistributionBoard_clicked",
    SITECONFIGURATION_ADD_CHARGER_CLICKED = "siteConfiguration_addCharger_clicked",
    ADD_CHARGER_MODAL_SEARCH_CLICKED = "addChargerModal_search_clicked",
    ADD_CHARGER_MODAL_ADD_NEW_CHARGER_LINK_CLICKED = "addChargerModal_addNewChargerLink_clicked",
    ADD_CHARGER_MODAL_ADD_CLICKED = "addChargerModal_add_clicked",
    SITECONFIGURATION_ADD_POWER_METER_CLICKED = "siteConfiguration_addPowerMeter_clicked",
    POWER_METER_MODAL_ADVANCED_SETTINGS_CLICKED = "powerMeterModal__advancedSettings_clicked",

    // Core device details page.
    DEVICEDETAILS_SITECONFIGURATION_CLICKED = "deviceDetails_siteConfiguration_clicked",
    SITECONFIGURATION_EDIT_SUB_DISTRIBUTION_BOARD_CLICKED = "siteConfiguration_editSubDistributionBoard_clicked",
    DEVICEDETAILS_DISTRIBUTION_BOARD_CHART_INPUT_SELECTOR_CLICKED = "deviceDetails_distributionBoardChartInputSelector_clicked",
    DEVICEDETAILS_DISTRIBUTION_BOARD_CHART_TIME_RANGE_LIVE_CLICKED = "deviceDetails_distributionBoardChartTimeRangeLive_clicked",
    DEVICEDETAILS_DISTRIBUTION_BOARD_CHART_TIME_RANGE_24_HOURS_CLICKED = "deviceDetails_distributionBoardChartTimeRange24Hours_clicked",
    DEVICEDETAILS_DISTRIBUTION_BOARD_CHART_TIME_RANGE_7_DAYS_CLICKED = "deviceDetails_distributionBoardChartTimeRange7Days_clicked",
    DEVICEDETAILS_DISTRIBUTION_BOARD_CHART_TIME_RANGE_30_DAYS_CLICKED = "deviceDetails_distributionBoardChartTimeRange30Days_clicked",
    DEVICEDETAILS_UPDATE_SOFTWARE_CLICKED = "deviceDetails_updateSoftware_clicked",
    UPDATE_SOFTWARE_MODAL_UPDATE_NOW_CLICKED = "updateSoftwareModal_updateNow_clicked",

    // Onboarding tutorial (IL-4090).
    ONBOARDING_TUTORIAL_STARTED = "onboardingTutorial_started",
    ONBOARDING_TUTORIAL_MODULE_COMPLETED = "onboardingTutorial_module_completed",
    ONBOARDING_TUTORIAL_MODULE_SKIPPED = "onboardingTutorial_module_skipped",
    ONBOARDING_TUTORIAL_OPTED_OUT = "onboardingTutorial_optedOut",
    ONBOARDING_TUTORIAL_COMPLETED = "onboardingTutorial_completed",
}

//chart constants
export const SERIES_COLORS: Array<string> = ["red", "#F4D528", "#4FC6DE"];

export enum PowerMeterMetricOptions {
    TotalActiveEnergyImportWh = "Total Active Energy Import",
    CurrentRmsA = "Current (A)",
    ActivePowerRmsW = "Power (kW)",
}

export const PRIVACY_POLICY_URL = "https://jetcharge.com.au/privacy-policy";
export const END_USER_AGREEMENT_URL = "https://jetcharge.com.au/end-use-terms";
export const STATUS_PAGE_URL = "https://status.jetcharge.com.au";

// Partner organisation.
export const EXTERNAL_ORGANISATION_ID_HEADER = "x-external-organisation-id";
export const ENABLE_PERMISSION_INSPECTOR = "enable-permission-inspector";

export const SURVEY_URL = "https://www.surveymonkey.com/r/illuminatesurvey";

export const CHARGEMATE_FIRMWARE_URL = "20.188.196.241";

// Maps and addresses
export const MAPS_API_KEY = "AIzaSyC1Y4wNFVPJA_oG7DSp9nk4sNufkXsV_b8";
export const MAP_ID = "general";

// Filters
export const FILTER_STATE_STORAGE_PREFIX = "filter"; // Stored in session storage
export const FILTER_VISIBILITY_STORAGE_PREFIX = "filter-visibility"; // Stored in local storage
export const COLUMN_VISIBILITY_STORAGE_PREFIX = "column-visibility"; // Stored in local storage
export const GRID_STATE_STORAGE_PREFIX = "grid-state"; // Stored in session storage
export const SESSION_GROUP_BY_PREFIX = "group-by-filter";

// Specific filters with shared updates/seeds
export const CUSTOMER_DEVICES_FILTER_STORAGE_KEY = "customer-devices";
export const MANAGE_CUSTOMERS_DEVICES_FILTER_STORAGE_KEY =
    "manage-customers-devices";

// Data table (headless TanStack table)
export const TABLE_STATE_STORAGE_PREFIX = "table-state"; // URL param key + sessionStorage key

// ApiResult error code where existing device id is returned in IdentityStr:
export const API_RESULT_DEVICE_EXISTS = 1010;

// Core
export const MIN_CORE_CONFIG_SEMVER = "3.0.0-0";
export const MIN_CORE_CHARGER_LOGS_SEMVER = "3.1.0-0";
export const MIN_CORE_CHARGER_FEEDBACK_SEMVER = "3.1.0-0";
export const MAX_SAMPLES = 64; // Number of downsample samples. This is the same number of data points as other status charts.
